import React from "react";
import { Box, Heading, Link, List, ListItem, Text, VStack } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

function scrollToBlogSection(e) {
  e.preventDefault();
  const el = document.getElementById("blog-section");
  if (el) {
    el.scrollIntoView({ behavior: "smooth" });
    window.history.replaceState(null, '', '#blog-section');
  } else {
    window.location.href = "/blog#blog-section";
  }
}

export default function CreditBuildingHabits2026() {
  return (
    <Box maxW="1000px" mx="auto" px={{ base: 4, md: 8 }} py={{ base: 20, md: 32 }}>
      <VStack spacing={6} align="start">
        <Link
          as="button"
          onClick={scrollToBlogSection}
          aria-label="Back to Blog"
          position="fixed"
          top={{ base: "84px", md: "96px" }}
          left={{ base: 4, md: 8 }}
          zIndex="sticky"
          bg="white"
          color="teal.600"
          fontWeight="semibold"
          border="1px solid"
          borderColor="teal.100"
          borderRadius="full"
          px={{ base: 0, sm: 4 }}
          py={{ base: 0, sm: 2 }}
          w={{ base: "42px", sm: "auto" }}
          h={{ base: "42px", sm: "auto" }}
          display="inline-flex"
          alignItems="center"
          justifyContent="center"
          boxShadow="sm"
          _hover={{ textDecoration: "none", bg: "teal.50" }}
        >
          <Text as="span" display={{ base: "inline", sm: "none" }}>←</Text>
          <Text as="span" display={{ base: "none", sm: "inline" }}>← Back to Blog</Text>
        </Link>
        <Heading as="h1" size="xl" mb={2} mt={16}>Top 7 Credit-Building Habits for 2026</Heading>
        <Text fontSize="sm" color="gray.500">
          By Heavenly • March 2026 • 5 mins read
        </Text>
        <Text>
          Building strong credit is more important than ever in 2026. Whether you’re new to credit or looking to boost your score, these habits will help you achieve your financial goals.
        </Text>
        <Heading as="h2" size="md">1) Pay Bills On Time</Heading>
        <Text>
          Your payment history is the single biggest factor in your credit score. Set reminders or automate payments to never miss a due date.
        </Text>
        <Heading as="h2" size="md">2) Keep Credit Utilization Low</Heading>
        <Text>
          Try to use less than 30% of your available credit. High balances can hurt your score, even if you pay in full each month.
        </Text>
        <Heading as="h2" size="md">3) Avoid Unnecessary Hard Inquiries</Heading>
        <Text>
          Each time you apply for new credit, a hard inquiry appears on your report. Too many in a short period can lower your score.
        </Text>
        <Heading as="h2" size="md">4) Monitor Your Credit Report</Heading>
        <Text>
          Check your credit report regularly for errors or fraud. You’re entitled to free reports from major bureaus every year.
        </Text>
        <Heading as="h2" size="md">5) Maintain a Mix of Credit Types</Heading>
        <Text>
          Having both revolving (credit cards) and installment (loans) accounts can benefit your score, as long as you manage them responsibly.
        </Text>
        <Heading as="h2" size="md">6) Don’t Close Old Accounts</Heading>
        <Text>
          The length of your credit history matters. Keep older accounts open, even if you use them rarely, to show a longer track record.
        </Text>
        <Heading as="h2" size="md">7) Set Financial Goals and Review Progress</Heading>
        <Text>
          Set clear credit goals—like reaching a certain score or qualifying for a loan—and review your progress every few months.
        </Text>
        <Heading as="h2" size="md">Final Thoughts</Heading>
        <Text>
          Good credit opens doors to better rates and more opportunities. Start with these habits and watch your score grow in 2026 and beyond.
        </Text>

        <Box mt={10} width="100%" textAlign="center">
          <Heading as="h3" size="md" mb={3} color="teal.700">Get an instant loan now with Swift Credit</Heading>
          <Link as={RouterLink} to="/apply" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
            <Box as="button" bg="teal.500" color="white" px={8} py={3} borderRadius="md" fontWeight="bold" _hover={{ bg: "teal.600" }}>
              Get a Loan
            </Box>
          </Link>
        </Box>
      </VStack>
    </Box>
  );
}
